import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight, Mail } from "lucide-react";

const Footer = ({ theme = "white" }) => {
  return (
    <div className={`footer footer-${theme} pt-10 bg-white`}>
      <div className="container md:flex pb-16 gap-x-6">
        <div className="flex-1">
          <Link to="/">
            <img
              className="h-10"
              src={require("../assets/img/Stabilize-Ai2.png")}
              alt="Logo"
            />
          </Link>

          <div className="text-sm text-gray-500 py-6">
            Stabilize-AI宁波如动科技是核心技术世界领先的人工智能科技公司，通过提供基于新理论的人工智能技术，让人工智能可以更好的应用在自动化、机器人和智慧世界等领域，为人工智能的应用开辟了广阔的疆土。
          </div>
        </div>

        <div className="flex-1">
          <div className="text-2xl text-[#3d3d3d]">快捷访问</div>

          <div className="py-10 text-sm md:block flex flex-wrap gap-x-4">
            <Link className="flex items-center py-1" to="/technology">
              <ArrowRight className="text-sm text-blue-600 w-4 h-4" />
              <div className="pl-2">核心技术</div>
            </Link>

            <Link className="flex items-center py-1" to="/solutions">
              <ArrowRight className="text-sm text-blue-600 w-4 h-4" />
              <div className="pl-2">解决方案</div>
            </Link>

            <Link className="flex items-center py-1" to="/products">
              <ArrowRight className="text-sm text-blue-600 w-4 h-4" />
              <div className="pl-2">产品矩阵</div>
            </Link>

            <Link className="flex items-center py-1" to="/about">
              <ArrowRight className="text-sm text-blue-600 w-4 h-4" />
              <div className="pl-2">关于我们</div>
            </Link>

            <Link className="flex items-center py-1" to="/contact">
              <ArrowRight className="text-sm text-blue-600 w-4 h-4" />
              <div className="pl-2">联系我们</div>
            </Link>
          </div>
        </div>

        <div className="flex-1">
          <div className="text-2xl text-[#3d3d3d]">订阅我们</div>

          <div className="flex mt-10">
            <input
              type="email"
              name="EMAIL"
              className="input-email flex-1 mr-2 bg-[#f6f6f6] text-[#575656] border-none rounded-md outline-0 h-[35px] px-3 py-2 text-sm"
              placeholder="输入您的邮箱，保持沟通"
              required
            />
            <div className="bg-blue-600 w-[34px] h-[34px] flex items-center justify-center rounded text-white">
              <Mail className="w-4 h-4" />
            </div>
          </div>

          <div className="mt-3 text-xs text-gray-400 leading-5">
            通过订阅，您将及时获取到Stabilize-AI宁波如动科技的最新动态
          </div>
        </div>
      </div>

      <div className="border-t border-gray-200 py-8">
        <p className="text-xs text-[#00B9D2] text-center">
          © Stabilize 宁波如动科技 版权所有
        </p>
      </div>
    </div>
  );
};

export default Footer;
